import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  CartPageQuery,
  CartListQuery,
  ShoppingCartDto,
  ShoppingCartAllAppVo,
  MemberDeliveryInfoVo,
  SaveDeliveryInfoRequest
} from './type';

/**
 * 分页查询购物车列表
  GET /api/order/cart/page
  接口ID：234956489
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-234956489
 */
export const getCartPage = (params: CartPageQuery): AxiosPromise<ShoppingCartDto> => {
  return request({
    url: '/api/order/cart/page',
    method: 'get',
    params
  });
};

/**
 * 获取购物车列表
  GET /api/order/cart/list
  接口ID：234956490
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-234956490
 */
export const getCartList = (params: CartListQuery): AxiosPromise<ShoppingCartAllAppVo> => {
  return request({
    url: '/api/order/cart/list',
    method: 'get',
    params
  });
};

// 获取保存过的发货信息
// GET /order/order/buyer/stored/delivery/info
// 接口ID：331081625
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-331081625
export const getSavedDeliveryInfo = (params: SaveDeliveryInfoRequest): AxiosPromise<MemberDeliveryInfoVo> => {
  return request({
    url: '/api/order/buyer/stored/delivery/info',
    method: 'get',
    params
  });
};
